import { BaseEntity } from "../base/base-entity";
import { ProcedureEntity } from "./procedure-entity";

export type ProcedureMailCfgType = {
  readonly procedureId: string;
  readonly recievedTemplate?: MailTemplate;
  readonly rejectedTemplate?: MailTemplate;
  readonly withdrawnTemplate?: MailTemplate;
  readonly completedTemplate?: MailTemplate;
};

export type MailTemplate = {
  title: string;
  body: string;
};

export class ProcedureMailCfg extends BaseEntity {
  public readonly procedureId: string;
  public readonly recievedTemplate?: MailTemplate;
  public readonly rejectedTemplate?: MailTemplate;
  public readonly withdrawnTemplate?: MailTemplate;
  public readonly completedTemplate?: MailTemplate;

  constructor(base: ProcedureMailCfgType) {
    super();
    this.procedureId = base.procedureId;
    this.recievedTemplate = base.recievedTemplate;
    this.rejectedTemplate = base.rejectedTemplate;
    this.withdrawnTemplate = base.withdrawnTemplate;
    this.completedTemplate = base.completedTemplate;
  }

  static newFrom(proc: ProcedureEntity): ProcedureMailCfg {
    return new ProcedureMailCfg({
      procedureId: proc.id,
    });
  }

  static fromJSON(json: ProcedureMailCfgType): ProcedureMailCfg {
    return new ProcedureMailCfg(json);
  }
}
